// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-container[data-v-5598f0c8]{position:relative;width:100%;border:1px solid #ccc;padding:4px}.user-image[data-v-5598f0c8]{width:100%;display:block}.image-upload-icon[data-v-5598f0c8]{position:absolute;bottom:0;right:0}.cus-camera-upload[data-v-5598f0c8],.cus-camera-upload-black[data-v-5598f0c8]{height:26px!important;width:26px!important;margin:0!important}", ""]);
// Exports
module.exports = exports;
